import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

export default () => {
    const { filters } = useProductFilters();

    return (filters.length > 0 && (
        <div class="ns-selected-filters px-5 pt-5 flex flex-nowrap flex-row w-full laptop:hidden">
            {filters.map(filter => (
                <button 
                    key={filter.value}
                    type="button"
                    class="ns-filter-tag flex flex-row justify-center items-center whitespace-nowrap"
                    onClick={() => filter.remove()}
                >
                    {filter.value} 
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 256 256" xml:space="preserve">
                        <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;" transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"><path d="M 2 90 c -0.512 0 -1.024 -0.195 -1.414 -0.586 c -0.781 -0.781 -0.781 -2.047 0 -2.828 l 86 -86 c 0.781 -0.781 2.047 -0.781 2.828 0 c 0.781 0.781 0.781 2.047 0 2.828 l -86 86 C 3.024 89.805 2.512 90 2 90 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/><path d="M 88 90 c -0.512 0 -1.023 -0.195 -1.414 -0.586 l -86 -86 c -0.781 -0.781 -0.781 -2.047 0 -2.828 c 0.78 -0.781 2.048 -0.781 2.828 0 l 86 86 c 0.781 0.781 0.781 2.047 0 2.828 C 89.023 89.805 88.512 90 88 90 z" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round"/></g>
                    </svg>
                </button>
            ))}
        </div>
    ))
}
